<template>
  <v-container class="fill-height py-16" style="max-width: 1200px">
    <v-row >
      <v-col cols="12">
        <v-card class="custom-card" height="100%">
          <v-card-title>Objetivos Gerais</v-card-title>
          <v-card-text style="color: white">
            Compreender e aplicar as leis e regulamentações de trânsito vigentes, a fim de cumprir rigorosamente as normas e, assim, conduzir com segurança, responsabilidade e maior consciência no trânsito.
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="custom-card" height="100%">
          <v-card-title>O que vou aprender?</v-card-title>
          <v-card-text style="color: white">
            <v-list
              density="compact"
              style="background: transparent; color: white"

            >
              <v-list-item style="color: white; padding: 0;">
                <v-list-item-icon>
                  <v-icon color="success">mdi-check</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  Introdução à Legislação de Trânsito Brasileira
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color: white; padding: 0;">
                <v-list-item-icon>
                  <v-icon color="success">mdi-check</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  Classificação das Infrações de Trânsito
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color: white; padding: 0;">
                <v-list-item-icon>
                  <v-icon color="success">mdi-check</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  Consequências das Infrações
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color: white; padding: 0;">
                <v-list-item-icon>
                  <v-icon color="success">mdi-check</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  Normas Gerais de Circulação e Conduta
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color: white; padding: 0;">
                <v-list-item-icon>
                  <v-icon color="success">mdi-check</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  Sinalização de Trânsito
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color: white; padding: 0;">
                <v-list-item-icon>
                  <v-icon color="success">mdi-check</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  Direitos e Deveres do Condutor
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color: white; padding: 0;">
                <v-list-item-icon>
                  <v-icon color="success">mdi-check</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  Prevenção de Acidentes Através do Cumprimento das Regras
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import topicos from "@/data/topicos.json";

export default {
  data() {
    return {
      topicos: topicos,
    };
  },

  computed: {},

  methods: {},
};
</script>

<style scoped>
.custom-card {
  background-color: transparent;
  border-radius: 8px;
  color: white;
  border: solid 1px white;
  box-shadow: none !important;
  padding: 16px 24px;
}
</style>
